module.exports = __webpack_public_path__ + "202408221624/img/diom_1.8f34b83b.png";